/**
 * Route configuration. allowedRoles: string (key in constants/roles) or array of keys (e.g. ['quality', 'operator']).
 * Public routes have no allowedRoles.
 */
import { ROLES } from '../constants/roles';

function resolveRoles(allowedRoles) {
  if (!allowedRoles) return null;
  if (Array.isArray(allowedRoles)) {
    return allowedRoles.flatMap((key) => ROLES[key] || []);
  }
  return ROLES[allowedRoles] || null;
}

export { ROLES, resolveRoles };

const routeConfig = [
  { path: '/login', component: 'Login' },
  { path: '/register', component: 'Register' },
  { path: '/pending', component: 'PendingApproval' },
  { path: '/operator/login', component: 'OperatorLogin' },
  { path: '/operator', component: 'OperatorApp', allowedRoles: 'operator' },
  { path: '/dashboard', component: 'Dashboard', allowedRoles: 'dashboard' },
  { path: '/audits', component: 'AuditList', allowedRoles: 'quality' },
  { path: '/audits/new', component: 'AuditForm', allowedRoles: 'quality' },
  { path: '/audits/:id', component: 'AuditDetail', allowedRoles: 'quality' },
  { path: '/audits/:id/edit', component: 'AuditForm', allowedRoles: 'quality' },
  { path: '/incoming-deliveries', component: 'IncomingDeliveries', allowedRoles: ['quality', 'operator'] },
  { path: '/incoming-deliveries/stock', component: 'IncomingStockOverview', allowedRoles: ['quality', 'operator'] },
  { path: '/incoming-deliveries/:id', component: 'IncomingDeliveryDetail', allowedRoles: ['quality', 'operator'] },
  { path: '/production-orders', component: 'ProductionOrders', allowedRoles: 'planners' },
  { path: '/production-orders/new', component: 'ProductionOrderForm', allowedRoles: 'planners' },
  { path: '/production-orders/:id/edit', component: 'ProductionOrderForm', allowedRoles: 'planners' },
  { path: '/production-planning', component: 'ProductionPlanning', allowedRoles: 'planners' },
  { path: '/administration/master-data', component: 'MasterDataManagement', allowedRoles: 'adminOnly' },
  { path: '/administration/users', component: 'UserManagement', allowedRoles: 'adminOnly' },
  { path: '/pallets', component: 'PalletList', allowedRoles: 'quality' },
  { path: '/pallets/:id', component: 'PalletDetail', allowedRoles: 'quality' },
  { path: '/supplier-documents', component: 'SupplierDocuments', allowedRoles: ['quality', 'purchasing'] },
  { path: '/profile', component: 'UserProfile', allowedRoles: 'general' },
  { path: '/help', component: 'Help', allowedRoles: 'general' },
  { path: '/production-recipes', component: 'ProductionRecipeList', allowedRoles: 'quality' },
  { path: '/production-recipes/new', component: 'ProductionRecipeForm', allowedRoles: 'quality' },
  { path: '/production-recipes/:id', component: 'ProductionRecipeForm', allowedRoles: 'quality' },
  { path: '/production-recipes/:id/edit', component: 'ProductionRecipeForm', allowedRoles: 'quality' },
  { path: '/production-sheet', component: 'ProductionSheetScreen', allowedRoles: 'general' },
  { path: '/shopfloor', component: 'ShopfloorMobileView', allowedRoles: 'general' },
  { path: '/receive-goods', component: 'ReceiveGoods', allowedRoles: 'general' },
  { path: '/production-start', component: 'ProductionStart', allowedRoles: 'general' },
  { path: '/stock', component: 'StockManagement', allowedRoles: 'general' },
  { path: '/recalls', component: 'RecallList', allowedRoles: 'quality' },
  { path: '/recalls/new', component: 'RecallForm', allowedRoles: 'quality' },
  { path: '/recalls/:id', component: 'RecallDetail', allowedRoles: 'quality' },
  { path: '/recalls/:id/edit', component: 'RecallForm', allowedRoles: 'quality' },
  { path: '/lot-trace', component: 'LotTraceGraph', allowedRoles: 'quality' },
  { path: '/compliance', component: 'ComplianceDashboard', allowedRoles: 'quality' },
  { path: '/trace-test-auto', component: 'TraceTestAutoGenerate', allowedRoles: 'quality' },
  { path: '/processes', component: 'ProcessViewer', allowedRoles: 'general' },
];

export default routeConfig;
